// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-recipes-container {
  display: flex;
  height: 100vh;
  font-family: 'Rubik', sans-serif;
}

.recipe-left-section {
  margin-top: 20px;
  flex: 1 1;
  border-right: 1px solid black;
  padding: 20px;
}

.recipe-right-section {
  flex: 2 1;
  padding: 20px;
  margin-top: 20px;
}

.recipe-card-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.recipe-left-section h2 {
  text-align: center;
}

.recipe-controls-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

.recipe-custom-dropdown {
  width: 100%;
  max-width: 250px;
}

.recipe-btn-create {
  padding: 10px 15px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.3s ease;
  background: #388E3C !important;
  color: white;
  border: none;
  display: flex;
  align-items: center;
  gap: 5px;
}

.recipe-btn-create:hover {
  background: #2E7D32 !important;
}

.recipe-error-text {
  color: red;
  text-align: center;
}

.recipe-image-thumbnail {
  width: 100%;
  height: 400px; 
  object-fit: contain;
  border-radius: 12px 12px 0 0;
  display: block;
  margin: 0;
  padding: 0;
  margin-top: 20px;
  margin-bottom: 60px;
}

.recipe-image-container {
  background-color: #A5D6A7;
  border-radius: 20px;
  padding: 0;
  text-align: center;
  height: 483px; 
  max-width: 500px;
  margin: 20px auto;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
  overflow: hidden; 
}

.selected-recipe-title {
  font-size: 24px;
  margin: 10px 0;
  font-weight: bold;
  color: #333;
  padding: 0 15px;
}

.recipe-action-buttons {
  display: flex;
  justify-content: center;
  gap: 15px;
  margin-top: 15px;
}

.recipe-action-buttons button {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  font-size: 1rem;
  cursor: pointer;
  transition: 0.3s;
}

.recipe-action-buttons button:hover {
  opacity: 0.8;
}

.recipe-btn-edit {
  background: #007bff;
  color: white;
}

.recipe-btn-delete {
  background: #dc3545;
  color: white;
}

.recipe-centered-message {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 35%;
  text-align: center;
  font-size: 1.2rem;
  color: black;
}

.recipe-success-message-container {
  position: fixed;
  top: 70px;
  left: 0;
  right: 0;
  z-index: 1000;
  display: flex;
  justify-content: center;
  pointer-events: none;
}

.recipe-success-message {
  color: green;
  background-color: #e8f5e9;
  border: 1px solid #4caf50;
  padding: 10px 20px;
  border-radius: 5px;
  font-weight: bold;
  box-shadow: 0 2px 10px rgba(0,0,0,0.1);
  display: inline-flex;
  align-items: center;
  gap: 8px;
  max-width: 80%;
  text-align: center;
  animation: recipeFadeInOut 3s ease-in-out forwards;
}

@keyframes recipeFadeInOut {
  0% { opacity: 0; transform: translateY(-20px); }
  10% { opacity: 1; transform: translateY(0); }
  90% { opacity: 1; transform: translateY(0); }
  100% { opacity: 0; transform: translateY(-20px); }
}

.recipe-modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.recipe-delete-modal {
  background-color: #A5D6A7;
  padding: 25px;
  border-radius: 8px;
  width: 400px;
  max-width: 90%;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.recipe-delete-modal h3 {
  margin-top: 0;
  color: #d32f2f;
  font-size: 1.3rem;
}

.recipe-delete-modal p {
  margin: 15px 0 25px;
  color: #555;
}

.recipe-modal-buttons {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

.recipe-modal-button {
  padding: 8px 16px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-weight: 500;
  transition: all 0.2s ease;
}

.recipe-modal-cancel {
  background-color: #f0f0f0;
  color: #333;
}

.recipe-modal-cancel:hover {
  background-color: #e0e0e0;
}

.recipe-modal-confirm {
  background-color: #d32f2f;
  color: white;
}

.recipe-modal-confirm:hover {
  background-color: #b71c1c;
}`, "",{"version":3,"sources":["webpack://./src/styles/AdminRecipeListPage.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,aAAa;EACb,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,SAAO;EACP,6BAA6B;EAC7B,aAAa;AACf;;AAEA;EACE,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,8BAA8B;EAC9B,YAAY;EACZ,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,4BAA4B;EAC5B,cAAc;EACd,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,iBAAiB;EACjB,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,SAAS;EACT,OAAO;EACP,QAAQ;EACR,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;EACjB,sCAAsC;EACtC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,cAAc;EACd,kBAAkB;EAClB,kDAAkD;AACpD;;AAEA;EACE,KAAK,UAAU,EAAE,4BAA4B,EAAE;EAC/C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,MAAM,UAAU,EAAE,wBAAwB,EAAE;EAC5C,OAAO,UAAU,EAAE,4BAA4B,EAAE;AACnD;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,oCAAoC;EACpC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,0CAA0C;AAC5C;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B","sourcesContent":[".admin-recipes-container {\n  display: flex;\n  height: 100vh;\n  font-family: 'Rubik', sans-serif;\n}\n\n.recipe-left-section {\n  margin-top: 20px;\n  flex: 1;\n  border-right: 1px solid black;\n  padding: 20px;\n}\n\n.recipe-right-section {\n  flex: 2;\n  padding: 20px;\n  margin-top: 20px;\n}\n\n.recipe-card-wrapper {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n}\n\n.recipe-left-section h2 {\n  text-align: center;\n}\n\n.recipe-controls-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n}\n\n.recipe-custom-dropdown {\n  width: 100%;\n  max-width: 250px;\n}\n\n.recipe-btn-create {\n  padding: 10px 15px;\n  font-size: 16px;\n  font-weight: 600;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  background: #388E3C !important;\n  color: white;\n  border: none;\n  display: flex;\n  align-items: center;\n  gap: 5px;\n}\n\n.recipe-btn-create:hover {\n  background: #2E7D32 !important;\n}\n\n.recipe-error-text {\n  color: red;\n  text-align: center;\n}\n\n.recipe-image-thumbnail {\n  width: 100%;\n  height: 400px; \n  object-fit: contain;\n  border-radius: 12px 12px 0 0;\n  display: block;\n  margin: 0;\n  padding: 0;\n  margin-top: 20px;\n  margin-bottom: 60px;\n}\n\n.recipe-image-container {\n  background-color: #A5D6A7;\n  border-radius: 20px;\n  padding: 0;\n  text-align: center;\n  height: 483px; \n  max-width: 500px;\n  margin: 20px auto;\n  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);\n  overflow: hidden; \n}\n\n.selected-recipe-title {\n  font-size: 24px;\n  margin: 10px 0;\n  font-weight: bold;\n  color: #333;\n  padding: 0 15px;\n}\n\n.recipe-action-buttons {\n  display: flex;\n  justify-content: center;\n  gap: 15px;\n  margin-top: 15px;\n}\n\n.recipe-action-buttons button {\n  padding: 10px 20px;\n  border: none;\n  border-radius: 8px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: 0.3s;\n}\n\n.recipe-action-buttons button:hover {\n  opacity: 0.8;\n}\n\n.recipe-btn-edit {\n  background: #007bff;\n  color: white;\n}\n\n.recipe-btn-delete {\n  background: #dc3545;\n  color: white;\n}\n\n.recipe-centered-message {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 35%;\n  text-align: center;\n  font-size: 1.2rem;\n  color: black;\n}\n\n.recipe-success-message-container {\n  position: fixed;\n  top: 70px;\n  left: 0;\n  right: 0;\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  pointer-events: none;\n}\n\n.recipe-success-message {\n  color: green;\n  background-color: #e8f5e9;\n  border: 1px solid #4caf50;\n  padding: 10px 20px;\n  border-radius: 5px;\n  font-weight: bold;\n  box-shadow: 0 2px 10px rgba(0,0,0,0.1);\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  max-width: 80%;\n  text-align: center;\n  animation: recipeFadeInOut 3s ease-in-out forwards;\n}\n\n@keyframes recipeFadeInOut {\n  0% { opacity: 0; transform: translateY(-20px); }\n  10% { opacity: 1; transform: translateY(0); }\n  90% { opacity: 1; transform: translateY(0); }\n  100% { opacity: 0; transform: translateY(-20px); }\n}\n\n.recipe-modal-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: rgba(0, 0, 0, 0.5);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.recipe-delete-modal {\n  background-color: #A5D6A7;\n  padding: 25px;\n  border-radius: 8px;\n  width: 400px;\n  max-width: 90%;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\n}\n\n.recipe-delete-modal h3 {\n  margin-top: 0;\n  color: #d32f2f;\n  font-size: 1.3rem;\n}\n\n.recipe-delete-modal p {\n  margin: 15px 0 25px;\n  color: #555;\n}\n\n.recipe-modal-buttons {\n  display: flex;\n  justify-content: flex-end;\n  gap: 12px;\n}\n\n.recipe-modal-button {\n  padding: 8px 16px;\n  border: none;\n  border-radius: 4px;\n  cursor: pointer;\n  font-weight: 500;\n  transition: all 0.2s ease;\n}\n\n.recipe-modal-cancel {\n  background-color: #f0f0f0;\n  color: #333;\n}\n\n.recipe-modal-cancel:hover {\n  background-color: #e0e0e0;\n}\n\n.recipe-modal-confirm {\n  background-color: #d32f2f;\n  color: white;\n}\n\n.recipe-modal-confirm:hover {\n  background-color: #b71c1c;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
